/**
 * Counts the number of active (non-empty) filter fields.
 * @param {Object} filters - An object where keys are filter field names and values are their current values.
 * @returns {number} The count of active filters.
 */
const getFilterCount = (filters) => {
  let count = 0;
  Object.values(filters).forEach((value) => {
    if (Array.isArray(value)) {
      if (value.length > 0) count++;
    } else if (typeof value === "string") {
      if (value !== "") count++;
    } else if (value !== null && value !== undefined) {
      count++;
    }
  });
  return count;
};

export default getFilterCount;
